import React, { useContext } from 'react';
import { View, Image, TouchableOpacity, Pressable } from 'react-native';

import PropTypes from 'prop-types';

import { Icon, VFText } from '@vfgroup-oneplatform/foundation/Components';
import { Fonts, useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';

import { getThemeImages } from '../../../Themes';
import ManageYourOrdersProps from '../../Screens/ManagerYourOrders/ManageYourOrders.context';

import styles from './InProgressOrdersSubCard.styles';

const InProgressOrdersSubCard = ({ orderId, item }) => {
  const manageYourOrdersProps = useContext(ManageYourOrdersProps);
  const theme = useTheme();
  const images = getThemeImages(theme.name);

  const onOrderItemPress = () => manageYourOrdersProps.onOrderItemPress(orderId, item.id);

  return (
    <View style={styles.card(theme)}>
      <View style={styles.itemNameContainer(theme)}>
        <VFText style={styles.itemNameText(theme)} i18nKey={item.title} />
        <TouchableOpacity style={styles.editItemContainer}>
          <VFText style={styles.itemEdit(theme)} i18nKey="my_orders_action_edit" />
          <Icon name={images.edit_pen} type="image" size={26} />
        </TouchableOpacity>
      </View>

      <Pressable onPress={onOrderItemPress}>
        <View style={styles.itemDetailsContainer}>
          <Image source={item.image} style={styles.image} />
          <View style={styles.itemDetailsSubContainer}>
            <View style={styles.itemDetailsSubContainerChild}>
              <VFText style={styles.statusText} i18nKey="my_orders_status" />
              <VFText style={[styles.statusText, Fonts.type.bold]} i18nKey={item.status} />
            </View>
            <View style={styles.itemDetailsSubContainerChild}>
              <VFText
                style={styles.statusText}
                i18nKey={
                  item.isInstallation ? 'my_orders_installation' : 'my_orders_estimated_delivery'
                }
              />
              <View style={styles.statusMultilineContainer}>
                <VFText style={[styles.statusText, Fonts.type.bold]} i18nKey={item.date} />
                {(item.startTime || item.endTime) && (
                  <VFText
                    style={[styles.statusText, Fonts.type.bold]}
                    i18nKey={item.endTime ? '%1$s - %2$s' : '%1$s'}
                    placeHolders={[item.startTime, item.endTime]}
                  />
                )}
              </View>
            </View>
          </View>
        </View>

        <View style={styles.itemUpdatedAtContainer}>
          <VFText
            style={styles.itemUpdatedAt(theme)}
            i18nKey="my_orders_last_updated_title"
            placeHolders={[item.updateDate, item.updateTime]}
          />
        </View>
      </Pressable>
    </View>
  );
};

InProgressOrdersSubCard.defaultProps = {
  isInstallation: false,
};

InProgressOrdersSubCard.propTypes = {
  orderId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  item: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    title: PropTypes.string.isRequired,
    image: PropTypes.object.isRequired,
    status: PropTypes.string.isRequired,
    isInstallation: PropTypes.bool,
    date: PropTypes.string.isRequired,
    startTime: PropTypes.string,
    endTime: PropTypes.string,
    updateDate: PropTypes.string.isRequired,
    updateTime: PropTypes.string.isRequired,
  }),
};

export default InProgressOrdersSubCard;
